<nv-modal #modal [isClosable]="false">
  <nv-loadingspinner
    [alwaysVisible]="true"
    [loading]="loading"
    (appear)="modal.open()"
    (disappear)="modal.close()"
  ></nv-loadingspinner>
  <ng-content></ng-content>
</nv-modal>
